import { ReactNode } from 'react';
import { HeaderWithData } from '@mlb/header';
import { Footer } from '@mlb/footer';
import { getLang } from '@gif/shared-global';
import styled from 'styled-components';

export interface PageLayoutProps {
  className?: string;
  children?: ReactNode;
  hideHeader?: boolean;
  hideFooter?: boolean;
  isUserLoggedIn?: boolean;
  ariaLabel: string;
}

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;

  > main {
    display: flex;
    flex: 1;
    flex-direction: column;
  }
`;

const lang = getLang();

export const PageLayout = ({
  className,
  children,
  hideHeader,
  hideFooter,
  isUserLoggedIn = false,
  ariaLabel,
}: PageLayoutProps) => (
  <PageContainer>
    {!hideHeader && (
      <HeaderWithData
        isLoggedIn={isUserLoggedIn}
        clubId="mlb"
        navigationPath="/_navs/header/mlb/global-nav"
        teamNameDisplay="MLB"
        locale={lang}
      />
    )}
    <main className={className} aria-label={ariaLabel}>
      {children}
    </main>
    {!hideFooter && (
      <Footer
        footerData={{
          menuItems: [],
          variables: [],
        }}
      />
    )}
  </PageContainer>
);

export default PageLayout;
